import { Wallet } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgWallet = mkIcon(Wallet);
